import { formatUrl, getOrderParams } from './payment-utils';
import { submitPayment, displayError } from './payment';
import { i18n } from '@/commons/utils';

const moduleData = {
  checkStatusTimer: null,
  code: null,
  container: null,
  countdown: null,
  data: null,
  isRedirected: false,
  onExpressConfirmation: () => null,
  url: null,
  title: null,
  titleText: null,
  total: null
};

export function init(params) {
  moduleData.container = params.container;
  moduleData.onExpressConfirmation = params.onExpressConfirmation;
  moduleData.url = params.url;
  moduleData.titleText = params.title;
  moduleData.data = params.data;
  renderExpress();
  events();
}

export function popupDisplayed() {
  const form = document.getElementById('qrForm');
  if (form != null) {
    form.submit();
  }
}

export function clearCheckStatusTimer() {
  clearInterval(moduleData.checkStatusTimer);
}

export function displayModalPaidOrder(data) {
  window.decathlon.tools.displayLoader(true, true);

  // Open WeChat PaymentPage in app
  window.location.href = data.redirectionUrl;

  // Display the order paid modal
  setTimeout(() => {
    // Hide the modale
    const wechatModal = $('#modal-wechat');
    if (wechatModal.is(':visible')) {
      wechatModal.modal('hide');
    }
    $('#modal-pay-order').modal('show');
  }, 3000);

  $('#modal-pay-order-yes').on('click', () => {
    checkPayedOrderForYesChoice(data.paymentGroupId, data.confirmationUrl, data.urlModalPaidOrderYes, data.timeoutBeforCheck, data.orderId);
  });

  $('#modal-pay-order-no').on('click', () => {
    $('#modal-pay-order').modal('hide');
    window.location.reload(true);
  });
  $('#payment-already-succeed-modal').on('hide.bs.modal', () => {
    window.location.href = $('#payment-already-succeed-input').attr('redUrl');
  });

  window.decathlon.tools.displayLoader(false, false);
}

/***
 * TODO this function was migrated from legacy code and is used only for regular checkout
 * express uses renderExpress, both processes should be harmonized
 * also, it's super long and terrifying, good luck :)
 */
export function qrCodeGenerator(data, paymentType = 'wechat') {
  window.decathlon.tools.displayLoader(true, true);

  const retryTimer = parseInt(data.retryTimer, 10);
  const initialCountdown = new Date().getTime() + retryTimer;
  const parsedURL = data.qrcodeUrl;
  const countdownRequest = parseInt(data.countdown, 10);
  const totalOfRequest = retryTimer / countdownRequest;
  const paymentGroupId = data.paymentGroupId;
  const orderId = data.orderId;
  const redirectionUrl = data.redirectionUrl;
  const redirectPspForm = data.redirectPspForm;
  const altPaymentGroupId = data.alternatifPaymentId;

  const container = $(`#${paymentType}-qrcode`);
  const modal = $(`#modal-${paymentType}`);
  const retryModal = $(`#modal-retry-${paymentType}`);
  const modalBody = $(`#modal-body-${paymentType}`);

  if (paymentType === 'alipay') {
    $('#alipay-form').append(redirectPspForm);
    const alipayFormElement = $('#alipay-form form');
    const action = alipayFormElement.attr('action');
    const serializedUrl = alipayFormElement.serialize();
    const requestUrl = `${action}?${serializedUrl}`;

    const alipayFrame = document.getElementById('alipayFrame');
    if (alipayFrame) {
      alipayFrame.setAttribute('src', requestUrl);
    }
  } else if (parsedURL && parsedURL !== '') {
    container.html('');
    container.qrcode({
      size: 230,
      color: '#3a3',
      text: parsedURL
    });
  } else {
    const messageError = i18n('TECH_0001');

    modalBody.html(`<center><strong><font color='red'>${messageError}</font></strong><br><br><button type='button' onClick="$('#modal-wechat').modal('hide')">Close</button></center>`);
    modal.modal('hide');
  }

  // Set data attributes
  modal
    .attr('data-payment-group-id', paymentGroupId)
    .attr('data-redirection-url', redirectionUrl)
    .attr('data-order-id', orderId)
    .attr('data-payment-type', paymentType)
    .attr('data-alt-payment-group-id', altPaymentGroupId);

  // Display timer
  const qrCodeTimer = container.attr('data-text');
  let timerContent;

  const qrCodeTimerText = document.querySelector('.qr-code-timer-text');
  if (qrCodeTimerText)
    qrCodeTimerText.remove();

  if (qrCodeTimer.includes('{0}')) {
    const timerContentText = qrCodeTimer.replace('{0}', '&nbsp;<span class="minutes"></span><span class="seconds"></span>&nbsp;');
    timerContent = `<p id="${paymentType}-countdown-before-retry" class='qr-code-timer-text' data-date="">${timerContentText}</p>`;
  } else {
    timerContent = `<p id="${paymentType}-countdown-before-retry" class='qr-code-timer-text' data-date=""><span class="minutes"></span><span class="seconds"></span> ${qrCodeTimer}</p>`;
  }

  modalBody.append(timerContent);
  const countdown = $(`#${paymentType}-countdown-before-retry`);
  countdown.attr('data-date', initialCountdown);
  window.decathlon.tools.countdown(countdown, () => {
    callBackQrCode(paymentType);
  });
  countdown.show();

  modal.modal('show');

  // Show the content, useful for retry
  modalBody.show();

  // Hide retry modal
  if (retryModal.length >= 1) {
    retryModal.hide();
  }

  hideOtherPayments();
  checkStatusLauncher(totalOfRequest, countdownRequest);
  window.decathlon.tools.displayLoader(false, false);
  scrollToQrcode();
}

export function checkStatus(callbackSuccess) {
  const checkParams = getOrderParams(moduleData.data);

  window.getAjaxHandler()
    .withUrl(formatUrl('checkCapturedStatus', checkParams.orderId))
    .withParameters(checkParams)
    .withSuccess((_, response) => onCheckStatusSuccess(response, checkParams, callbackSuccess))
    .withError(onCheckStatusError)
    .call();
}

function renderExpress() {
  /* Clean container */
  const qrcode = document.querySelector('.dkt-express-checkout-qrcode');
  if (qrcode !== null) {
    qrcode.parentNode.removeChild(qrcode);
  }

  const countdown = document.querySelector('.dkt-express-checkout-countdown');
  if (countdown !== null) {
    countdown.parentNode.removeChild(countdown);
  }

  const retryButton = document.querySelector('.dkt-express-checkout-retry-button');
  if (retryButton !== null) {
    retryButton.parentNode.removeChild(retryButton);
  }

  /* Render title */
  if (!moduleData.title) {
    moduleData.title = document.createElement('h3');
    moduleData.title.className = 'dkt-express-checkout-method-title';
    moduleData.title.innerHTML = moduleData.titleText;
    moduleData.container.appendChild(moduleData.title);
  } else {
    moduleData.title.classList.remove('dkt-express-checkout-method-title--retry');
  }

  /* Render Total */
  if (!moduleData.total) {
    moduleData.total = document.createElement('span');
    moduleData.total.className = 'dkt-express-checkout-total';
    moduleData.container.appendChild(moduleData.total);
  }
  moduleData.total.innerHTML = window.expressCheckoutStore.total;

  /* Render QR Code */
  if (moduleData.data.qrcodeUrl) {
    moduleData.code = document.createElement('div');
    moduleData.code.className = 'dkt-express-checkout-qrcode';
    $(moduleData.code).qrcode({
      size: 200,
      color: '#3a3',
      text: moduleData.data.qrcodeUrl
    });
    moduleData.container.appendChild(moduleData.code);
  } else {
    // 1 render iframe
    const iframe = document.createElement('iframe');
    iframe.setAttribute('scrolling', 'no');
    iframe.setAttribute('src', 'about:blank');
    iframe.setAttribute('name', 'iframe-qrcode');
    iframe.setAttribute('id', 'iframe-qrcode');
    iframe.className = 'dkt-express-checkout-iframe-qrcode';
    moduleData.container.appendChild(iframe);

    // 2 append form
    const template = document.createElement('template');
    template.innerHTML = moduleData.data.redirectPspForm;
    const form = template.content.firstChild;
    form.style.display = 'none';
    form.setAttribute('target', 'iframe-qrcode');

    document.body.appendChild(form);
    //3 => popupDisplayed, submit form and target iframe.
  }

  /* Render countdown */
  moduleData.countdown = document.createElement('span');
  moduleData.countdown.className = 'dkt-express-checkout-countdown';
  moduleData.container.appendChild(moduleData.countdown);
  makeCountdown({
    container: moduleData.countdown,
    duration: parseInt(moduleData.data.retryTimer, 10),
    checkDelay: parseInt(moduleData.data.countdown, 10) / 1000,
    checkMethod: checkStatus,
    countdownEnd: displayRetryExpress
  });
}

function events() {
  document.addEventListener('closeExpress', () => {
    clearInterval(moduleData.countdownTimer);
  });
}

function makeCountdown(params) {
  let total = Math.floor(params.duration) / 1000;
  let delay = 0;
  moduleData.countdownTimer = setInterval(() => {
    let minutes = Math.floor(total / 60);
    let seconds = Math.floor(total % 60);
    minutes = (minutes < 10) ? `0${minutes}` : minutes;
    seconds = (seconds < 10) ? `0${seconds}` : seconds;
    params.container.innerHTML = `${minutes}:${seconds}`;

    if (total === 0) {
      clearInterval(moduleData.countdownTimer);
      params.countdownEnd();
    }

    if (delay === params.checkDelay) {
      params.checkMethod();
      delay = 0;
    }

    delay += 1;
    total -= 1;
  }, 1000);
}

function onCheckStatusSuccess(response, params, callbackSuccess) {
  const data = response.result.data;

  if (data && data.reloadExpressCartridge === 'true') {
    clearInterval(moduleData.countdownTimer);
    moduleData.onExpressConfirmation(data.redirectConfirmation);
  } else if (data && data.redirectConfirmation === 'true') {
    if (moduleData.isRedirected === false) {
      applyRedirectConfirmation(data.redirectConfirmation, data.redirectionUrl, true);
    }
  } else if (params && params.alternativePayment && params.alternativePayment !== undefined) {
    submitPayment(true, params.alternativePayment);
  } else if (callbackSuccess && typeof callbackSuccess === 'function') {
    callbackSuccess();
  }
}

function onCheckStatusError() {
  window.location.reload();
}

function applyRedirectConfirmation(redirectConfirmation, redirectionUrl, withoutPopup) {
  // Redirect the user to confirmation page
  moduleData.isRedirected = true;


  if (withoutPopup === false) {
    const stringToCheck = redirectionUrl.split('&');
    const statusString = stringToCheck[1].split('=');

    if (statusString[1] === 'SUCCESS') {
      $('#modal-wechat').modal('hide');
      $('#modal-alipay').modal('hide');
      $('#payment-already-succeed-modal').modal('show');
    }

    setTimeout(() => {
      moduleData.isRedirected = false;
      window.location.href = redirectionUrl;
    }, 3000);
  } else {
    moduleData.isRedirected = true;
    window.location.href = redirectionUrl;
  }
}

function displayRetryExpress() {
  const qrcode = document.querySelector('.dkt-express-checkout-qrcode');
  if (qrcode !== null) {
    qrcode.parentNode.removeChild(qrcode);
  }

  const qrcodeIframe = document.querySelector('.dkt-express-checkout-iframe-qrcode');
  if (qrcodeIframe !== null) {
    qrcodeIframe.parentNode.removeChild(qrcodeIframe);
  }

  const countdown = document.querySelector('.dkt-express-checkout-countdown');
  if (countdown !== null) {
    countdown.parentNode.removeChild(countdown);
  }

  const total = document.querySelector('.dkt-express-checkout-total');
  if (total !== null) {
    total.parentNode.removeChild(total);
  }

  moduleData.title.classList.add('dkt-express-checkout-method-title--retry');

  const retryButton = document.createElement('button');
  retryButton.className = 'dkt-express-checkout-retry-button cta blue right';
  retryButton.innerHTML = 'Retry';
  retryButton.setAttribute('data-tnr-qrcode-retry-button', ''); // NRT
  retryButton.onclick = () => {
    window.expressCheckoutStore.payment.submitPayment();
  };

  moduleData.container.appendChild(retryButton);
}

function checkStatusLauncher(numberOfRequest, timeForRequest) {
  let requests = Math.floor(numberOfRequest);

  moduleData.checkStatusTimer = setInterval(() => {
    if (requests !== 0) {
      requests -= 1;
      checkStatus();
    } else {
      clearInterval(moduleData.checkStatusTimer);
    }
  }, timeForRequest);
}

function callBackQrCode(paymentType) {
  $(`#modal-body-${paymentType}`).hide();
  $(`#modal-retry-${paymentType}`).show();
  $(`#${paymentType}-countdown-before-retry`).remove();
}

function hideOtherPayments() {
  const otherPayments = $('#payment-fragment');

  if (otherPayments.length > 0) {
    otherPayments.hide();
  }
}

function scrollToQrcode() {
  const containerParent = $('#modal-express-payment-layout');

  containerParent.animate({
    scrollTop: containerParent.prop('scrollHeight') - containerParent.height()
  }, 500);
}

function checkPayedOrderForYesChoice(paymentGroupId, redirectionUrl, trackingUrl, timeoutBeforeCheck, orderId) {
  window.decathlon.tools.displayLoader(true, true);

  const params = {
    paymentGroupId,
    orderId,
    redirectionUrl,
    trackingUrl
  };

  setTimeout(() => {
    window.getAjaxHandler()
      .withUrl(formatUrl('checkCapturedStatus', orderId))
      .withParameters(params)
      .withSuccess((_, resp) => {
        $('#modal-pay-order').modal('hide');
        window.decathlon.tools.displayLoader(false, false);

        if (resp.responseTO !== undefined && resp.responseTO.errors.length > 0) {
          const error = resp.responseTO.errors[0];
          displayError(i18n(error.code));
        } else {
          const result = resp.result.data;
          if (result.redirectConfirmation === 'true') {
            applyRedirectConfirmation(result.redirectConfirmation, result.redirectionUrl, true);
          } else {
            window.location.href = trackingUrl;
          }
        }
      })
      .call();
  }, timeoutBeforeCheck);
}



// WEBPACK FOOTER //
// ./src/checkout/payment/payment-qrcode.js